import { LoadbearingStructure, ProductsCount } from 'shared/types';

export const getStructuresWithProducts = (productsCount: ProductsCount[]) =>
  Object.values(LoadbearingStructure).filter((structure) =>
    productsCount.some(
      (item) => item.structureType === structure && item.count > 0
    )
  );
